import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutExciseTaxCodeLookup extends Layout {
    sourceExcisetaxcode: DataSource;
    tableTaxCodeLookup: Table;
}
